import { render } from "./insertCRMWhatsappContactFollowupView.vue?vue&type=template&id=1a303592&scoped=true"
import script from "./insertCRMWhatsappContactFollowupView.vue?vue&type=script&lang=js"
export * from "./insertCRMWhatsappContactFollowupView.vue?vue&type=script&lang=js"

import "./insertCRMWhatsappContactFollowupView.vue?vue&type=style&index=0&id=1a303592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a303592"]])

export default __exports__